/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import { connect } from 'react-redux';
import { PureComponent } from 'react';
import { CALL_ME_BACK_POPUP_ID } from 'Component/CallMeBackPopup/CallMeBackPopup.config';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import { showPopup } from 'Store/Popup/Popup.action';
import history from 'Util/History';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import {
    TYPE_CATEGORY,
    TYPE_CMS_PAGE,
} from 'SourceRoute/UrlRewrites/UrlRewrites.config';

const CmsBlocksAndMenuDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../../store/CmsBlocksAndMenu/CmsBlocksAndMenu.dispatcher'
);

import Footer from './Footer.component';

/** @namespace Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    title: state.MetaReducer.title,
    urlRewrite: state.UrlRewritesReducer.urlRewrite,
    copyright: state.ConfigReducer.copyright,
    isInfoLoading: state.ProductListInfoReducer.isLoading,
    isProductsLoading: state.ProductListReducer.isLoading,
    isUrlLoading: state.UrlRewritesReducer.isLoading,
    device: state.ConfigReducer.device,
    newsletterActive: state.ConfigReducer.newsletter_general_active,
    blocks: state.CmsBlocksAndMenuReducer.blocks,
    brand: state.ProductReducer
});

/** @namespace Component/Footer/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showPopup: (payload) => dispatch(showPopup(CALL_ME_BACK_POPUP_ID, payload)),
    getMenuAndBlocks: (options) =>  CmsBlocksAndMenuDispatcher.then(
        ({default: dispatcher}) => dispatcher.handleData(dispatch, options))
});

/** @namespace Component/Footer/Container */
export class FooterContainer extends PureComponent {
    state = {
        title : null,
        showFooter : true
    };

    static getDerivedStateFromProps(props, state) {
      return { title : props.title };
    }

    componentDidMount(){
        this.getCmsBlocks();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.delayFooterVisibility(prevProps);
    }



    // Delay Footer visibility
    // Fix for big footer appearing when one is coming back from pdp ro plp
    delayFooterVisibility(prevProps){
        const { urlRewrite } = this.props;
        const { urlRewrite : prevUrlRewrite } = prevProps;
        if(urlRewrite.type && urlRewrite.type !== prevUrlRewrite.type){
            if([TYPE_CATEGORY,'BRAND_ATTRIBUTE',TYPE_CMS_PAGE].includes(urlRewrite.type)){
                this.setState({ showFooter : false})
                let component = this;
                setTimeout(()=>{
                    component.setState({ showFooter : true})
                },3000)
            }
        }
    }

    getCmsBlocks() {
        const { getMenuAndBlocks } = this.props;
        const { pathname } = location;

        // getMenuAndBlocks({
        //     identifiers: [ 
        //         'header_top_promo',
        //         'checkout_footer_links',
        //         'footer_middle_left',
        //         'footer_bottom',
        //         'footer_links_block',
        //         'footer_top',
        //         'footer_middle_left',
        //         'footer_bottom' 
        //     ]
        // });
    }

    containerProps() {
        const { history, device, newsletterActive, copyright, showPopup, blocks, urlRewrite, brand } = this.props;
        const {
            location: {
                pathname
            },
            title
        } = history;

        const isCheckout = pathname.includes(CHECKOUT_URL);

        return {
            isCheckout,
            device,
            newsletterActive,
            copyright,
            showPopup,
            blocks,
            pathname,
            urlRewrite,
            brand
        }
    }

    render() {
        const { showFooter} = this.state;
        const { isInfoLoading, isProductsLoading, isUrlLoading, urlRewrite  } = this.props;

        // conditional Footer visibility
        // Fix for big footer appearing when one is coming back from pdp ro plp
        switch (urlRewrite.type){
            case TYPE_CATEGORY:
                if(isInfoLoading || isProductsLoading){
                    return null;
                }
                break;
            case 'BRAND_ATTRIBUTE':
                if(urlRewrite.is_fashion || urlRewrite.is_hero){
                    if(isProductsLoading){
                        return null;
                    }
                }else {
                    if(isInfoLoading || isProductsLoading){
                        return null;
                    }
                }
                break;
            default:
        }

        if(!showFooter || isUrlLoading)
            return null;

        return (
            <Footer
                { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
